import { tns } from 'tiny-slider/src/tiny-slider';

class TestimonialsSlider {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		this.initSlider();
		this.handleResize = this.debounce(this.updateHeight.bind(this), 150);
		window.addEventListener('resize', this.handleResize);
		this.updateHeight(); // Initial height calculation
	}

	initSlider() {
		this.slider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			autoplayTimeout: 10000,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			onInit: () => {
				this.el.closest('.block-testimonials__testimonials-row--slider')?.classList.remove('slider-hidden');
				this.el.closest('.block-testimonials__testimonials-row--slider')?.classList.add('slider-visible');
			}

		});
	}

	updateHeight() {
		if (!this.el) return;

		let maxHeight = 0;
		const slides = this.el.querySelectorAll('.block-testimonials__testimonial-slide');

		slides.forEach(slide => {
			slide.style.height = 'auto'; // reset height
			maxHeight = Math.max(maxHeight, slide.offsetHeight);
		});

		this.el.style.height = `${maxHeight}px`;
	}

	debounce(func, wait) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}
}

export default TestimonialsSlider;